<template>
  <div class="map">
    <div class="vrijLogo"><p class="vrij">Vrij!</p></div>
    <Lintje class="menu" :kaart="true" :minimap="minimap"/>
    <Mapbox :interactive="true"/>
    <MaandSlider class="slider"/>
    <DayStepper class="daystepper"/>
  </div>
</template>
<style scoped>
.map {
  height: 100vh;
}
.slider {
  position: fixed;
  left: 0px;
  z-index: 10000;
  top: 120px;
}
.menu {
  right: 145px;
  position: fixed;
  z-index: 10002;
}

.vrijLogo {
  position: fixed;
  transition: left 500ms ease-in-out;
  z-index: 20000;
  margin: 10px;
}

.vrijLogo .vrij {
  font-family: BornReady, Arial, Helvetica, sans-serif;
  color: #f18e05;
  font-size: 60px;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0;
}

.daystepper {
  position: fixed;

  bottom: 0px;
}
</style>

<script>
/**
  De view voor maand/kaart met de 'encyclopedische gegevens'
 */
import Mapbox from "../components/Mapbox.vue";
import MaandSlider from "../components/MaandSlider.vue";
import Lintje from "../components/Lintje.vue";
import DayStepper from "../components/Daystepper.vue"

export default {
  name: "Map",
  data() {
    return {
      minimap: true
    };
  },
  components: {
    Mapbox,
    MaandSlider,
    Lintje,
    DayStepper
  }
};
</script>